export module POPUP_INJECT {
  export const REF = "popupRef";
  export const COMPONENT = "popupComponent";
  export const CONFIG = "popupConfig";
  export const DATA = "popupData";
  export const WIZARD_STATE = "wizard-state";
  export const WIZARD_NEXT_FN = "wizard-next-fn";
}

export interface PopupRef<T> {
  close(result?: T): Promise<void>;

  confirm(result?: T): Promise<void>;

  updateHeight?(height?: number): void;
}
